import { AppThunk } from '../../../store/rootReducer';
import { CHANGE_LEAD } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';
import { AnalyticsLeadPlot } from '../types/analytics.types';

export const trackChangeLead =
  (
    newLeads: string[],
    previousLeads: string[],
    plot: AnalyticsLeadPlot,
    sendToAnalytics = track,
  ): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    sendToAnalytics({
      name: CHANGE_LEAD,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        plot,
        previous_leads: previousLeads,
        new_leads: newLeads,
      },
    });
  };
